import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { replace } from 'connected-react-router';

import { useActionDispatcher } from '../../hooks';
import {
  createPromotionCodeRequest,
  initPromotionCodeRequest,
  resetCurrentPromotionCode,
} from '../../store/modules/promotion-codes/actions';
import PromotionCodeForm from './PromotionCodeForm';
import {
  isPromotionCodePersistent,
  selectPromotionCode,
} from '../../store/modules/promotion-codes/selectors';

const PromotionCodeCreate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(initPromotionCodeRequest());
    return () => {
      dispatch(resetCurrentPromotionCode());
    };
  }, [dispatch]);

  const createPromotionCode = useActionDispatcher(createPromotionCodeRequest);

  const persistent = useSelector(isPromotionCodePersistent);
  const promotionCode = useSelector(selectPromotionCode);

  useEffect(() => {
    if (persistent) {
      dispatch(replace(`/dashboard/admin/promotion-codes/${promotionCode.data!.id}`));
    }
  }, [persistent, promotionCode.data, dispatch]);

  return (
    <PromotionCodeForm
      creatingMode
      record={promotionCode}
      onSubmit={createPromotionCode}
    />
  );
};

export default PromotionCodeCreate;
